import React from 'react';
import { Platform, TouchableOpacity } from 'react-native';
import theme from '../../constants/theme.style';
import CustomText from '../customText/CustomText';

export const MainButton = ({
  title = 'button',
  btnBgColor,
  textColor,
  btnTextSize,
  btnPress,
  btnWidth,
  btnPadding,
  btnMarginTop,
  btnMarginBottom,
}) => (
  <TouchableOpacity
    style={{
      marginLeft: 'auto',
      marginRight: 'auto',
      backgroundColor: btnBgColor,
      borderRadius: theme.BUTTON_BORDER_RADIUS,
      marginTop: btnMarginTop,
      marginBottom: btnMarginBottom,
      width: btnWidth,
      textAlign: 'center',
      ...Platform.select({
        web: { outlineColor: theme.GREEN_LIGHT_COLOR, outlineOffset: 5 },
      }),
    }}
    onPress={btnPress}
    accessibilityRole="button"
  >
    <CustomText
      style={{
        color: textColor,
        fontSize: btnTextSize,
        padding: btnPadding,
        textAlign: 'center',
      }}
      testID="button"
    >
      {title}
    </CustomText>
  </TouchableOpacity>
);
